import { formatDuration } from 'date-fns';
import { ru } from 'date-fns/locale';
import urlJoin from 'url-join';

import { Deposit } from '@sravni/react-icons';

import Currency from '../../../constants/currency';
import { ACTION_TYPE, PRODUCT_TYPE } from '../../../interfaces/recentAction';
import { IDepositsData } from '../types/actionDataTypes';
import { IRecentActionCard } from '../types/recentActionCard';

import { addThousandSpaces } from './changeData';

export const getDepositsData = (data: IDepositsData): IRecentActionCard | null => {
    const { meta, payload } = data;
    const { step, url } = meta

    const amountString = payload.amount ? `Вклад ${addThousandSpaces(payload.amount)} ${Currency[payload.currency.toUpperCase()]}` : '';
    const period = `на ${formatDuration({
        years: payload.periodType.toLowerCase() === 'year' ? payload.period : 0,
        months: payload.periodType.toLowerCase() === 'month' ? payload.period : 0,
    }, { locale: ru })}`
    const percent = `под ${payload.percent}%`

    const deposit: IRecentActionCard = {
        actionId: data.actionId,
        cardColor: 'blue',
        hintColor: undefined,
        buttonVariant: 'outlined',
        icon: <Deposit />,
        description: `${amountString} ${period} ${percent}`,
        buttonText: 'Перейти',
        link: urlJoin(url, `?orderId=${meta.externalId}`),
        product: `${PRODUCT_TYPE.DEPOSITS}-${ACTION_TYPE.SEARCH_RESULTS_V2}`,
      };

    switch (step.toLowerCase()) {
        case 'search':{
            deposit.hint = 'Выберите банк для вашего вклада'
            deposit.description = `${amountString} ${period}`
            deposit.buttonText = 'Продолжить'
            return deposit;
        }
        case 'needesia':
        case 'needauthorise': {
            deposit.hint = 'Заполните анкету через Госуслуги'
            return deposit;
        }
        case 'needverifyclient': {
            deposit.hint = 'Подтвердите личность'
            return deposit;
        }
        case 'awaitpayments': {
            deposit.hint = 'Пополните вклад'
            return deposit;
        }
        default: return null
    }
}